/**
 * @flow
 * @relayHash 658ac6336a10da9355d589e70233bb00
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteIntegrationEventInput = {|
  id: string
|};
export type DeleteIntegrationEventMutationVariables = {|
  input: DeleteIntegrationEventInput
|};
export type DeleteIntegrationEventMutationResponse = {|
  +deleteIntegrationEvent: {|
    +deletedId: string
  |}
|};
export type DeleteIntegrationEventMutation = {|
  variables: DeleteIntegrationEventMutationVariables,
  response: DeleteIntegrationEventMutationResponse,
|};
*/


/*
mutation DeleteIntegrationEventMutation(
  $input: DeleteIntegrationEventInput!
) {
  deleteIntegrationEvent(input: $input) {
    deletedId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteIntegrationEventInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteIntegrationEvent",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteIntegrationEventPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "deletedId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteIntegrationEventMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteIntegrationEventMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteIntegrationEventMutation",
    "id": null,
    "text": "mutation DeleteIntegrationEventMutation(\n  $input: DeleteIntegrationEventInput!\n) {\n  deleteIntegrationEvent(input: $input) {\n    deletedId\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd61ea1781ef4a859f2fec66873e293e0';
module.exports = node;
